import moment from 'moment';
import { getFarthestKeyMoment } from '@/utils/keyMoments';
import { PHASES } from '@/store/availableActions/utils/const';
import { doesCandidateParticipate, isEventClosed } from '@/store/availableActions/utils/event';

export function isEventParticipationDisabled({ editMode, eventPhases, event, user }) {
  return !editMode && (isEventClosed(eventPhases) ||
    (moment().isAfter(getFarthestKeyMoment(event, PHASES.DISCOVERING)) && (!user || !doesCandidateParticipate(event))))
}